export default {
  "common": {
    "success": "Xong",
    "requestFailed": "Yêu cầu thất bại. Vui lòng thử lại.",
    "networkError": "Lỗi mạng. Vui lòng thử lại.",
    "requestTimeout": "Yêu cầu này kéo dài quá lâu. Vui lòng thử lại.",
    "retry": "Thử lại",
    "loading": "Đang tải",
    "language": "Ngôn ngữ",
    "country": "Quốc gia",
    "region": "Khu vực",
    "timezone": "Múi giờ",
    "save": "Lưu",
    "cancel": "Hủy",
    "confirm": "Xác nhận",
    "reply": "Trả lời"
  },
  "notice": {
    "close": "Đóng thông báo",
    "successTitle": "Hoàn thành",
    "errorTitle": "Hành động thất bại",
    "warningTitle": "Xác nhận hành động này",
    "infoTitle": "Thông báo",
    "confirmEyebrow": "KIỂM TRA HÀNH ĐỘNG",
    "alertEyebrow": "THÔNG BÁO STARLIVE"
  },
  "nav": {
    "home": "Trang chủ",
    "discover": "Khám phá",
    "friends": "Bạn bè",
    "messages": "Hộp thư đến",
    "profile": "Tôi",
    "studio": "Phòng thu",
    "search": "Tìm kiếm"
  },
  "seo": {
    "title": "StarLive - Video ngắn, Phát trực tiếp, Phim truyền hình, Tiểu thuyết, Âm nhạc và Trò chơi",
    "pages": {
      "home": "Trang chủ",
      "discover": "Khám phá các vở kịch, tiểu thuyết, âm nhạc và trò chơi",
      "message": "Bạn bè",
      "profile": "Hồ sơ"
    },
    "descriptions": {
      "home": "Khám phá các video ngắn, livestream, phim truyện ngắn, tiểu thuyết, âm nhạc và trò chơi nhỏ trên StarLive. Theo dõi các nhà sáng tạo và tiếp tục ở bất cứ đâu.",
      "discover": "Khám phá các phim ngắn phổ biến, tiểu thuyết, âm nhạc và trò chơi nhỏ trên StarLive, duyệt thứ hạng, tìm kiếm tiêu đề và tiếp tục trên nhiều thiết bị.",
      "message": "Xem thông báo tương tác, trực tiếp, giao dịch, đánh giá và hệ thống trên StarLive.",
      "profile": "Quản lý hồ sơ StarLive của bạn, người theo dõi, mục yêu thích, lịch sử, giao dịch, quyền truy cập nhà sáng tạo và ví của bạn."
    }
  },
  "brand": {
    "home": "StarLive tại nhà",
    "join": "Tham gia StarLive"
  },
  "feed": {
    "more": "Xem thêm",
    "follow": "Theo dõi",
    "followed": "Theo dõi",
    "refresh": "Làm mới",
    "loading": "Khuyến nghị tải",
    "empty": "Chưa có nội dung",
    "preparing": "Đang chuẩn bị nội dung đề xuất cho bạn",
    "preparingTip": "Nội dung sẽ sớm xuất hiện",
    "videoFailed": "Video không tải được",
    "checkNetwork": "Kiểm tra kết nối và thử lại",
    "unavailable": "Nội dung này hiện không khả dụng",
    "login": "Đăng nhập",
    "muteOn": "Bật âm thanh",
    "muteOff": "tắt tiếng",
    "qualityLow": "Bộ tiết kiệm dữ liệu"
  },
  "a11y": {
    "home": "StarLive tại nhà",
    "videoChannels": "Kênh video",
    "search": "Tìm kiếm",
    "authorContent": "Danh mục nội dung của người sáng tạo",
    "creatorProfile": "Xem hồ sơ người sáng tạo",
    "viewComments": "Xem bình luận",
    "imagePosition": "Ảnh {current} / {total}",
    "addBookshelf": "Thêm vào giá sách",
    "removeBookshelf": "Gỡ khỏi giá sách",
    "searchDiscover": "Tìm kiếm kịch, tiểu thuyết và âm nhạc",
    "discoverChannels": "Khám phá các kênh",
    "loading": "Đang tải",
    "banner": "Chuyển sang banner {index}",
    "moreActions": "Nhiều hành động hơn",
    "backDiscover": "Quay lại Khám phá",
    "share": "Chia sẻ",
    "closePlayer": "Người chơi đóng vai",
    "more": "Xem thêm",
    "closeDirectory": "Đóng thư mục",
    "exitReader": "Trình đọc thoát",
    "chapterDirectory": "Thư mục chương",
    "refreshRanking": "Làm mới thứ hạng",
    "notificationSettings": "Cài đặt thông báo",
    "messageCategories": "Danh mục tin nhắn",
    "searchPage": "Tìm kiếm và khám phá",
    "back": "Quay lại",
    "clearKeyword": "Xóa từ khóa",
    "resultTypes": "Các loại kết quả tìm kiếm",
    "backProfile": "Quay lại hồ sơ",
    "logout": "Đăng xuất ra"
  },
  "locale": {
    "title": "Ngôn ngữ & quốc gia"
  },
  "settingsUi": {
    "title": "Bối cảnh",
    "eyebrow": "TÀI KHOẢN & AN TOÀN",
    "account": "Tài khoản & tùy chọn",
    "languageCountry": "Ngôn ngữ & quốc gia",
    "languageCountryTip": "Chọn ngôn ngữ giao diện và quốc gia nội dung của bạn",
    "notifications": "Cài đặt thông báo",
    "notificationsTip": "Quản lý các chuyển đổi thông báo trong ứng dụng và đẩy",
    "legal": "Chính sách & hướng dẫn",
    "terms": "Điều khoản dịch vụ",
    "termsTip": "Xem lại điều khoản dịch vụ và quy tắc sử dụng tài khoản",
    "privacy": "Chính sách bảo mật",
    "privacyTip": "Tìm hiểu cách xử lý thông tin cá nhân và quyền lợi của bạn",
    "logout": "Đăng xuất ra",
    "logoutTip": "Đăng xuất khỏi tài khoản StarLive này",
    "logoutConfirm": "Đăng xuất khỏi tài khoản hiện tại?",
    "back": "Quay lại với tôi",
    "community": "Hướng dẫn Cộng đồng",
    "communityTip": "Xem lại các quy tắc về đăng bài, tương tác, phát trực tiếp và an toàn"
  },
  "legalUi": {
    "version": "Phiên bản {version}",
    "effective": "Hiệu quả: {date}",
    "updated": "Cập nhật lần cuối: {date}",
    "loading": "Đang tải tài liệu",
    "loadFailed": "Không thể tải tài liệu",
    "unavailable": "Tài liệu này hiện không có sẵn. Thử lại sau.",
    "back": "Quay lại",
    "registerPrefix": "Tôi đã đọc và đồng ý với",
    "legalNotice": "Trang này hiển thị phiên bản hiện tại được nền tảng phát hành."
  },
  "centerPayment": {
    "exchangeRate": "US${dollars} = {coins} đồng xu",
    "wechat": "WeChat Pay",
    "alipay": "Alipay",
    "paypal": "PayPal"
  },
  "player": {
    "play": "Lối chơi",
    "progress": "Tiến độ phát lại"
  },
  "search": {
    "recent": "Tìm kiếm gần đây",
    "clearAll": "Dọn sạch tất cả",
    "trending": "Đang thịnh hành ngay bây giờ",
    "liveHeat": "Độ phổ biến trực tiếp",
    "users": "Người dùng",
    "videos": "Video ngắn",
    "live": "TRỰC TIẾP",
    "viewAll": "Xem tất cả",
    "noMatch": "Không có kết quả cho \"{keyword}\"",
    "noMatchTip": "Hãy thử một từ khóa ngắn hơn hoặc khám phá những gì người khác đang xem.",
    "recommended": "Đề xuất cho bạn"
  },
  "inbox": {
    "title": "Hộp thư đến",
    "empty": "Chưa có tin nhắn nào",
    "emptyTip": "Chúng tôi sẽ thông báo cho bạn ngay khi có điều gì mới xảy ra."
  },
  "discover": {
    "title": "Khám phá",
    "watchNow": "Xem ngay",
    "readNow": "Đọc ngay",
    "recentSearch": "Tìm kiếm gần đây",
    "hotSearch": "Tìm kiếm xu hướng",
    "dramas": "Phim ngắn",
    "novels": "Tiểu thuyết",
    "music": "Âm nhạc",
    "games": "Trò chơi nhỏ",
    "dramaDetail": "Chi tiết vở kịch",
    "novelDetail": "Chi tiết tiểu thuyết",
    "episodes": "Các tập phim",
    "episodeTitle": "Tập phim {no} · {title}",
    "related": "Liên quan",
    "intro": "Về tác phẩm này",
    "directory": "Mục lục",
    "readersLike": "Độc giả cũng thích",
    "chapterDirectory": "Thư mục chương",
    "ascending": "đang đi lên",
    "descending": "đang đi xuống",
    "results": "{count} kết quả",
    "loadFailed": "Nội dung không tải được",
    "searching": "Đang tìm kiếm",
    "continueExperience": "Tiếp tục",
    "hotDramas": "Các bộ phim truyền hình nổi tiếng",
    "hotNovels": "Tiểu thuyết phổ biến",
    "hotMusic": "Nhạc phổ biến",
    "hotGames": "Các trò chơi nhỏ phổ biến",
    "rankings": "Bảng xếp hạng phổ biến",
    "forYou": "Dành cho bạn"
  },
  "discoverUi": {
    "featured": "Nổi bật",
    "drama": "Phim ngắn",
    "novel": "Tiểu thuyết",
    "music": "Âm nhạc",
    "game": "Trò chơi nhỏ",
    "all": "Tất cả",
    "continueWatch": "Tiếp tục xem",
    "continueRead": "Tiếp tục đọc",
    "continueListen": "Tiếp tục nghe",
    "continuePlay": "Tiếp tục chơi",
    "progressEpisode": "Tập cuối xem {count}",
    "progressChapter": "Chương đọc lần cuối {count}",
    "progressMusic": "Lần chơi cuối tại {time}",
    "latestChapter": "Cập nhật đến chương {count}",
    "finished": "Hoàn thành",
    "serializing": "Đang diễn ra",
    "updateTo": "Cập nhật thành tập {count}",
    "episodesCount": "{current}/{total} tập",
    "heat": "{value} độ phổ biến",
    "playCount": "{count} vang lên",
    "playNow": "Chơi ngay",
    "free": "Miễn phí",
    "fullRanking": "Xếp hạng đầy đủ",
    "hotRank": "Đọc nhiều nhất",
    "newRank": "Phát hành mới",
    "finishedRank": "Hoàn thành",
    "bookshelf": "Giá sách của tôi",
    "emptyDrama": "Không có phim truyền hình trùng khớp",
    "emptyNovel": "Không có tiểu thuyết trùng khớp",
    "emptyMusic": "Không có nhạc phù hợp",
    "emptyGame": "Không có trò chơi nhỏ ghép đôi",
    "end": "Bạn đã đến cuối cùng",
    "refresh": "Làm mới kênh này",
    "dramaHotRank": "Những bộ phim truyền hình nổi bật",
    "novelHotRank": "Tiểu thuyết được đọc nhiều nhất",
    "novelNewRank": "Bảng xếp hạng tiểu thuyết mới",
    "novelFinishedRank": "Bảng xếp hạng tiểu thuyết hoàn chỉnh",
    "musicHotRank": "Âm nhạc hàng đầu",
    "musicNewRank": "Âm nhạc mới",
    "gameHotRank": "Các trò chơi nhỏ hàng đầu",
    "gameNewRank": "Trò chơi nhỏ mới",
    "decoration": "Phong cách"
  },
  "discoverBadge": {
    "hot": "Xu hướng",
    "new": "Mới",
    "newMusic": "Mới",
    "editorsPick": "Lựa chọn của biên tập viên",
    "finished": "Hoàn thành",
    "exclusive": "Độc quyền",
    "limitedFree": "Miễn phí giới hạn",
    "updatedToday": "Cập nhật hôm nay",
    "popularRead": "Phổ biến",
    "newBook": "Mới",
    "hit": "Hit"
  },
  "discoverCategory": {
    "drama": {
      "recommend": "Khuyến nghị",
      "hot": "Xu hướng",
      "new": "Mới",
      "finished": "Hoàn thành",
      "city": "đô thị",
      "sweet": "Tình yêu ngọt ngào",
      "revenge": "Sự trở lại",
      "mystery": "Bí ẩn",
      "costume": "Giai đoạn"
    },
    "novel": {
      "recommend": "Khuyến nghị",
      "male": "Dành cho nam",
      "female": "Dành cho phụ nữ",
      "fantasy": "Fantasy",
      "city": "đô thị",
      "romance": "Lãng mạn",
      "mystery": "Bí ẩn",
      "history": "Lịch sử",
      "scifi": "Khoa học viễn tưởng",
      "finished": "Hoàn thành"
    },
    "music": {
      "recommend": "Khuyến nghị",
      "hot": "Xu hướng",
      "new": "Mới",
      "pop": "Pop",
      "light": "Nhạc dễ nghe",
      "electronic": "Điện tử",
      "healing": "Bình tĩnh"
    },
    "game": {
      "recommend": "Khuyến nghị",
      "hot": "Xu hướng",
      "new": "Mới",
      "casual": "Casual",
      "puzzle": "Câu đố",
      "reaction": "phản xạ"
    }
  },
  "musicUi": {
    "nowPlaying": "Đang chơi",
    "single": "Độc thân",
    "play": "Lối chơi",
    "pause": "Tạm dừng",
    "previous": "Bài hát trước đó",
    "next": "Bài hát tiếp theo",
    "loopMode": "Đường ray vòng lặp",
    "favorite": "Yêu thích",
    "myFavorites": "Những ca khúc yêu thích trong âm nhạc",
    "addFavorite": "Thêm vào mục yêu thích",
    "removeFavorite": "Xóa khỏi mục yêu thích",
    "favoriteAdded": "Đã thêm vào mục yêu thích",
    "favoriteRemoved": "Đã xóa khỏi mục yêu thích",
    "playFailed": "Nhạc không tải được. Thử lại sau.",
    "lyrics": "Lời bài hát",
    "noLyrics": "Không có lời bài hát",
    "collapse": "Collapse lyric player",
    "miniPlayer": "Máy phát nhạc mini",
    "openLyrics": "Chế độ xem lời bài hát mở",
    "closePlayer": "Đóng mini player",
    "bannerType": "STARLIVE MUSIC",
    "dramaBannerType": "PHIM NGẮN",
    "novelBannerType": "TIỂU THUYẾT GỐC"
  },
  "gameUi": {
    "bannerType": "TRẬN ĐẤU STARLIVE",
    "featuredLabel": "LỰA CHỌN TRẬN ĐẤU STARLIVE",
    "myFavorites": "Các trò chơi được yêu thích",
    "playNow": "Chơi ngay",
    "playCount": "{count} vang lên",
    "addFavorite": "Thêm trò chơi vào mục yêu thích",
    "removeFavorite": "Xóa yêu thích",
    "favoriteAdded": "Trò chơi được thêm vào mục yêu thích",
    "favoriteRemoved": "Trò chơi đã bị loại khỏi mục yêu thích",
    "close": "Trận đấu cân bằng",
    "internalGame": "Trò chơi nhỏ StarLive",
    "externalGame": "Trò chơi nhỏ bên ngoài",
    "externalTip": "Trò chơi này được cung cấp bởi bên thứ ba. Mở nó trong trình duyệt nếu nó không tải được ở đây.",
    "openBrowser": "Mở trong trình duyệt",
    "startGame": "Bắt đầu trò chơi",
    "restartGame": "Khởi động lại",
    "playAgain": "Chơi lại",
    "roundProgress": "Tròn {current}/{total}",
    "reactionTitle": "phản xạ neon",
    "reactionHint": "Chờ tín hiệu chuyển sang màu xanh lam, rồi chạm ngay. Một cú chạm sớm sẽ khởi động lại vòng đấu.",
    "reactionState": {
      "idle": "Bạn đã sẵn sàng chưa?",
      "waiting": "Chờ đã...",
      "ready": "Chạm ngay",
      "early": "Quá sớm",
      "result": "Giữ sự tập trung",
      "finished": "Hoàn thành thử thách"
    },
    "milliseconds": "{value} ms",
    "bestReaction": "Phản ứng tốt nhất",
    "averageReaction": "Trung bình",
    "memoryTitle": "Ký ức Ánh Sao",
    "memoryHint": "Lật hai lá bài và khớp biểu tượng của chúng với càng ít nước đi càng tốt.",
    "memoryMoves": "Các nước đi",
    "memoryPairs": "Cặp đôi",
    "cardRevealed": "Lá bài được tiết lộ",
    "cardHidden": "Lá bài ẩn",
    "bestScore": "Điểm số tốt nhất {score}",
    "scoreSaved": "Điểm số {score} đã lưu"
  },
  "center": {
    "title": "Tôi",
    "grow": "Mở rộng năng lực của bạn",
    "titles": "Các tựa đề của tôi",
    "wornTitle": "Tiêu đề của tôi",
    "frames": "Khung hình avatar",
    "honor": "Bức tường danh dự",
    "recharge": "Chọn số tiền nạp lại",
    "orders": "Nạp lại lệnh",
    "profileStudio": "Hãy biến hồ sơ của bạn thành của riêng bạn",
    "profileTip": "Chi tiết đã lưu sẽ xuất hiện trên hồ sơ của bạn và trong các tin nhắn tương tác.",
    "editProfile": "Chỉnh sửa hồ sơ",
    "empty": "Chưa có gì ở đây",
    "chooseAvatar": "Chọn một avatar",
    "publicProfile": "Hồ sơ công khai",
    "genderDisplay": "Hiển thị giới tính"
  },
  "titleCatalog": {
    "title": "Tất cả các tựa đề",
    "back": "Trở lại với sự phát triển",
    "viewAll": "Xem tất cả",
    "progress": "{acquired} / {total} đã mở khóa",
    "description": "Mỗi tựa game đều được mở khóa nhờ hoạt động thực tế. Trang bị bất kỳ tựa game nào bạn sở hữu và xem xét yêu cầu đối với các tựa game bị khóa.",
    "requirement": "Yêu cầu mở khóa",
    "acquiredAt": "Mở khóa tại",
    "locked": "Không mở khóa",
    "rarity": {
      "common": "Thông thường",
      "rare": "Hiếm",
      "epic": "sử thi",
      "limited": "Giới hạn"
    }
  },
  "centerRefresh": {
    "pull": "Kéo để làm mới",
    "release": "Phát hành để làm mới",
    "refreshing": "Thật sảng khoái...",
    "updated": "Hồ sơ được cập nhật"
  },
  "centerUi": {
    "overview": "Tổng quan",
    "content": "Nội dung",
    "growth": "Phát triển",
    "wallet": "Ví",
    "following": "Theo dõi",
    "fans": "Người theo dõi",
    "receivedLikes": "Sở thích",
    "liked": "Thích",
    "favorite": "Yêu thích",
    "favoriteTypes": "Các loại nội dung yêu thích",
    "favoriteVideo": "Video",
    "favoriteNovel": "Tiểu thuyết",
    "favoriteMusic": "Âm nhạc",
    "favoriteGame": "Trò chơi",
    "history": "Lịch sử",
    "purchased": "Đã mua",
    "myFavorites": "Những bài yêu thích của tôi",
    "watchHistory": "Lịch sử đồng hồ",
    "purchasedContent": "Nội dung đã mua",
    "watchLater": "Tiếp tục xem sau",
    "manageHistory": "Quản lý lịch sử xem",
    "purchasedAvailable": "Có thể áp dụng ngay cả sau khi hủy niêm yết",
    "creator": "Người tạo video ngắn",
    "streamer": "Người dẫn chương trình trực tiếp",
    "contentCategories": "Danh mục nội dung",
    "viewMode": "Kiểu hiển thị",
    "listView": "Hiển thị danh sách",
    "gridView": "Lưới ba cột"
  },
  "levelUi": {
    "consumptionLevel": "Mức chi tiêu",
    "levelTitle": "Tiêu đề màn chơi",
    "totalSpent": "Chi tiêu đủ điều kiện",
    "remaining": "Lên cấp độ tiếp theo",
    "progressLabel": "Tiến trình cấp độ",
    "maxReached": "Mức tối đa đạt được",
    "selectGenderNotice": "Không chọn giới tính. \"{title}\" được hiển thị mặc định. Chọn một để sử dụng tiêu đề cấp độ tương ứng.",
    "chooseGender": "Chọn",
    "levelBenefits": "Lợi ích cấp hiện tại",
    "levelIconAlt": "Biểu tượng cấp độ {level}",
    "floatingUnlocked": "Banner cấp độ đã được mở khóa",
    "noFloating": "Chưa có banner cấp độ nào",
    "milestones": "Các cột mốc cấp độ",
    "unlocked": "đã mở khóa",
    "unlockAt": "Mở khóa ở cấp độ {level}"
  },
  "levelDetail": {
    "title": "Mức chi tiêu",
    "back": "Quay lại hồ sơ",
    "openAria": "Xem mức chi tiêu và các cột mốc lợi ích",
    "heroDescription": "Mỗi giao dịch mua đủ điều kiện sẽ nâng cấp của bạn. Đồng xu đã nạp lại sẽ không được tính cho đến khi chúng được sử dụng.",
    "swipeEyebrow": "CÁC CỘT MỐC LỢI ÍCH",
    "swipeTitle": "Vuốt qua các mức lợi ích",
    "position": "{current} / {total}",
    "current": "Cấp độ hiện tại",
    "locked": "Đã khóa",
    "unlockSpend": "Mở khóa sau khi sử dụng {amount} xu",
    "titleRight": "Tiêu đề cấp độ mới",
    "iconRight": "Biểu tượng cấp độ mới",
    "bannerRight": "Banner cấp độ mới",
    "configured": "Quyền lợi có sẵn",
    "notConfigured": "Không có sẵn ở cấp độ này",
    "bannerAlt": "Banner cấp {level}",
    "previous": "Xem mức lợi ích trước đây",
    "next": "Xem cấp lợi ích tiếp theo",
    "genderNotice": "Không chọn giới tính. Một tiêu đề StarLive trung lập sẽ được hiển thị cho đến khi bạn chọn một tựa.",
    "benefitMilestones": "Mức quyền lợi mới",
    "nextBenefitEyebrow": "Quyền lợi mới tiếp theo",
    "nextBenefitLevel": "Mở khóa ở cấp độ {level}",
    "levelsAway": "{count}Các tầng cách đó",
    "coinsAway": "Chi tiêu {amount} nhiều xu hơn",
    "nextBenefit": "Lợi ích tiếp theo",
    "newBenefit": "Lợi ích mới",
    "allBenefitsUnlocked": "Tất cả các lợi ích cấp độ đều được mở khóa"
  },
  "creator": {
    "shop": "Quà tặng & nội dung độc quyền",
    "supportTab": "Hỗ trợ",
    "gifts": "Gửi quà tặng",
    "tips": "Hãy ủng hộ người sáng tạo này",
    "noWorks": "Chưa có tác phẩm nào",
    "noPremium": "Chưa có nội dung độc quyền nào",
    "actions": "Hành động nội dung"
  },
  "studioBusiness": {
    "heroDescription": "Quản lý tác phẩm, kiếm tiền trực tiếp và mọi khoản thu nhập đã được xác minh.",
    "navigation": "Các phần của Creator Studio",
    "tips": "Hỗ trợ",
    "paid": "Độc quyền",
    "income": "Lợi nhuận",
    "withdrawableIncome": "Lợi nhuận có thể rút",
    "viewIncome": "Xem chi tiết lợi nhuận",
    "createTip": "Tạo mục hỗ trợ",
    "createPaid": "Xuất bản nội dung độc quyền",
    "tipProject": "Mục hỗ trợ",
    "paidContent": "Nội dung trả phí độc quyền",
    "title": "Tiêu đề",
    "description": "Mô tả",
    "coinPrice": "Giá đồng xu",
    "icon": "Biểu tượng mặt hàng",
    "contentType": "Loại nội dung",
    "assetUrls": "Liên kết tài sản (tùy chọn)",
    "assetUrlsPlaceholder": "Bạn cũng có thể nhập một liên kết hình ảnh hoặc video cho mỗi dòng",
    "localUpload": "Tải lên từ thiết bị",
    "uploadAlbumAssets": "Tải lên hình ảnh album độc quyền",
    "uploadVideoAsset": "Tải lên video độc quyền",
    "albumLimit": "Tối đa 20 hình ảnh, mỗi ảnh dung lượng 10MB",
    "videoLimit": "Một video, dung lượng lên đến 120MB",
    "chooseAssets": "Chọn ảnh hoặc tệp",
    "chooseAssetsTip": "JPG, PNG, WebP, MP4, WebM hoặc MOV",
    "uploadingAssets": "Tải lên tài sản",
    "choosePaidCover": "Tải lên bìa nội dung",
    "paidCoverTip": "Tùy chọn · JPG, PNG hoặc WebP",
    "assetIndex": "Tài sản {index}",
    "removeAsset": "Xóa tài sản",
    "assetsUploaded": "Tài sản {count} được tải lên",
    "albumLimitReached": "Một album trả phí có thể chứa tối đa 20 hình ảnh",
    "tipTitlePlaceholder": "Ví dụ: hỗ trợ sản xuất tiếp theo",
    "tipDescriptionPlaceholder": "Giải thích các quỹ hỗ trợ và kết quả dự kiến",
    "paidTitlePlaceholder": "Đặt tên rõ ràng cho nội dung độc quyền",
    "paidDescriptionPlaceholder": "Mô tả nội dung, người tạo và quyền truy cập sau khi mua",
    "reviewTip": "Lưu lại và gửi để xem xét. Các mặt hàng được phê duyệt sẽ được liệt kê tự động trên hồ sơ người sáng tạo của bạn.",
    "requiredTip": "Nhập tiêu đề, giá và tài sản nội dung hợp lệ",
    "noTips": "Chưa có vật dụng hỗ trợ nào",
    "noPaid": "Chưa có nội dung độc quyền nào",
    "emptyTip": "Tạo bản nháp và gửi đi. Các mục được phê duyệt sẽ xuất hiện trên hồ sơ người sáng tạo của bạn.",
    "totalIncome": "Lợi nhuận trọn đời đã được xác minh",
    "giftIncome": "Thu nhập từ quà tặng",
    "tipIncome": "Hỗ trợ thu nhập",
    "paidIncome": "Thu nhập từ nội dung độc quyền",
    "noIncome": "Chưa có lợi nhuận",
    "incomeRule": "Chỉ các đơn hàng quà tặng, hỗ trợ và nội dung trả phí thành công mới được bao gồm.",
    "fromUser": "Từ {name}",
    "anonymous": "Người dùng StarLive",
    "unknownItem": "Mục dành cho người sáng tạo",
    "icon_coffee": "Cà phê",
    "icon_flower": "Hoa",
    "icon_energy": "Năng lượng",
    "icon_light": "Chiếu sáng",
    "icon_food": "Ẩm thực",
    "icon_kitchen": "Nhà bếp",
    "icon_star": "Ánh sao"
  },
  "studioPreview": {
    "open": "Xem trước \"{title}\"",
    "close": "Xem trước đóng",
    "work": "Xem trước công việc",
    "live": "Xem trước trực tiếp",
    "paidVideo": "Xem trước video độc quyền",
    "paidAlbum": "Xem trước album độc quyền",
    "unavailable": "Mục này chưa có tài sản nào có thể xem trước.",
    "playFailed": "Không thể tải nội dung này",
    "playFailedTip": "Kiểm tra URL phát lại hoặc kết nối của bạn, sau đó thử lại.",
    "retry": "Chơi lại",
    "imageAlt": "{title}, hình ảnh {index}",
    "imageCount": "{current} / {total}",
    "goToImage": "Xem hình ảnh {index}",
    "previous": "Hình ảnh trước",
    "next": "Hình tiếp theo",
    "ownerNotice": "Bản xem trước chỉ dành cho người sáng tạo này không thay đổi trạng thái đánh giá hoặc danh sách công khai."
  },
  "studioComments": {
    "eyebrow": "KIỂM SOÁT CỘNG ĐỒNG",
    "title": "Bình luận công việc · {count}",
    "setting": "Quyền bình luận",
    "allowed": "Bình luận về",
    "disabled": "Tắt bình luận",
    "disabledHint": "Tác giả đã tắt bình luận và phản hồi mới cho tác phẩm này.",
    "disableTitle": "Tắt bình luận",
    "disableConfirm": "Bình luận hiện có sẽ vẫn giữ nguyên, nhưng người dùng và người sáng tạo không thể thêm bình luận hoặc phản hồi. Tiếp tục à?",
    "enabledSuccess": "Bật bình luận",
    "disabledSuccess": "Tắt bình luận",
    "creatorPlaceholder": "Trả lời với tư cách là người tạo...",
    "remove": "Xóa bình luận",
    "removeConfirm": "Xóa bình luận của {name} khỏi tác phẩm này?",
    "removed": "Bình luận đã bị xóa"
  },
  "studioManager": {
    "manage": "Quản lý",
    "eyebrow": "KIỂM SOÁT CÔNG VIỆC",
    "title": "Quản lý công việc",
    "preview": "Xem trước tác phẩm",
    "previewTip": "Phát nguồn gốc gốc của người tạo",
    "comments": "Quản lý bình luận",
    "commentsTip": "Xem, trả lời và quản lý bình luận {count}",
    "commentsAllowedTip": "Người dùng có thể thêm bình luận và phản hồi mới",
    "commentsDisabledTip": "Các ý kiến hiện có vẫn còn; Bình luận và phản hồi mới đã bị tắt",
    "editContent": "Chỉnh sửa tác phẩm",
    "editContentTip": "Cập nhật tiêu đề, mô tả, bìa và cài đặt nội dung",
    "submitTip": "Gửi tác phẩm này cho quản trị viên để xem xét",
    "hideTip": "Xóa nó khỏi các trang công khai; có thể được xuất bản lại sau",
    "republishTip": "Khôi phục tác phẩm này về các trang công khai",
    "endLiveTip": "Kết thúc phiên làm việc trực tiếp hiện tại",
    "startLiveTip": "Nhập ID TikTok và xác minh phiên trực tiếp",
    "deleteTip": "Xóa bản nháp hoặc tác phẩm bị từ chối; điều này không thể đảo ngược",
    "giftDetail": "Chi tiết quà tặng",
    "giftDetailEyebrow": "SỔ CÁI QUÀ TẶNG TRỰC TIẾP",
    "giftCoins": "Tiền xu quà tặng",
    "giftOrders": "Sự kiện quà tặng",
    "giftQuantity": "Số lượng quà tặng",
    "giftItem": "{gift} × {count}",
    "noLiveGifts": "Không có quà trong cuộc sống này",
    "noLiveGiftsTip": "Các bản ghi chi tiết sẽ xuất hiện tại đây khi khán giả gửi quà trong buổi livestream này."
  },
  "giftUi": {
    "sectionTitle": "Gửi quà tặng",
    "dialogTitle": "Xác nhận quà tặng",
    "toCreator": "Gửi đến {name}",
    "confirmPay": "Thanh toán và gửi quà tặng",
    "confirmText": "Trả {amount} xu để gửi {count} × \"{title}\"?",
    "sent": "Đã gửi {count} × \"{title}\"",
    "notificationTitle": "Đã gửi quà",
    "notificationContent": "Việc mua quà đã hoàn tất và được tính vào mức chi tiêu của bạn.",
    "receivedTitle": "Bạn đã nhận được quà tặng từ người sáng tạo",
    "receivedContent": "{actor} đã gửi cho bạn một món quà. Mở Creator Studio để xem lại."
  },
  "dialog": {
    "comments": "Bình luận",
    "authorProfile": "Hồ sơ người sáng tạo",
    "report": "Gửi báo cáo",
    "share": "Chia sẻ công việc",
    "creatorApply": "Đăng ký trở thành nhà sáng tạo",
    "confirmGift": "Xác nhận quà tặng",
    "confirmTip": "Xác nhận hỗ trợ",
    "paidContent": "Nội dung trả phí",
    "wallet": "Tiền xu & mua sắm",
    "notificationSettings": "Cài đặt thông báo",
    "roleApply": "Áp dụng dưới dạng {role}",
    "creatorRole": "người tạo video ngắn",
    "hostRole": "chủ nhà"
  },
  "desktop": {
    "inbox": "Mỗi phản hồi đều xứng đáng được xem",
    "profile": "Theo dõi sự phát triển của bạn và lưu lại mọi yêu thích",
    "discover": "Truyện ngắn bắt đầu và trang sách vẫn tiếp tục lật",
    "feed": "Vuốt lên để khám phá khoảnh khắc tiếp theo",
    "inboxDescription": "Tương tác, cảnh báo trực tiếp, giao dịch và đánh giá đều xuất hiện ở đây.",
    "profileDescription": "Hồ sơ, nội dung, lợi ích phát triển và ví tiền của bạn đều có ở đây.",
    "discoverDescription": "Khám phá các bộ phim truyền hình và tiểu thuyết, từ khám phá đến xem và đọc.",
    "feedDescription": "Việc liên tục xem và tương tác sẽ cải thiện các đề xuất của bạn."
  },
  "wallet": {
    "coins": "Tiền xu",
    "transactions": "Giao dịch",
    "purchases": "Mua sắm"
  },
  "centerDetail": {
    "avatarAlt": "Avatar người dùng",
    "bioPlaceholder": "Viết một tiểu sử ngắn để mọi người có thể hiểu bạn.",
    "edit": "Chỉnh sửa",
    "growthProgress": "Tiến trình tăng trưởng",
    "experience": "{current} / {next} XP",
    "watchedPercent": "{percent}% người xem",
    "delistedPurchased": "Đã hủy niêm yết · Vẫn còn hàng sau khi mua",
    "emptyTip": "Khám phá trang chủ để tìm thứ bạn thích.",
    "clearHistory": "Lịch sử đồng hồ rõ ràng",
    "equipped": "Được trang bị",
    "equip": "Trang bị",
    "notEquipped": "Không được trang bị",
    "inUse": "Đang sử dụng",
    "use": "Ứng dụng",
    "benefitsCount": "Lợi ích tăng trưởng {count} được mở khóa",
    "balance": "Số dư đồng xu",
    "frozen": "Đóng băng {amount}",
    "processing": "Xử lý {amount}",
    "fixedTiers": "Số tiền cố định",
    "available": "Có sẵn",
    "pendingConfig": "Yêu cầu thiết lập",
    "creatingOrder": "Đang sạc lại...",
    "createOrder": "Nạp lại ngay",
    "priceBase": "Giá trị nạp",
    "paymentFee": "Phí thanh toán",
    "paymentTotal": "Tổng phải trả",
    "securePaymentNote": "Chỉ cộng xu sau khi máy chủ xác nhận. Việc quay lại trang không chứng minh thanh toán thành công.",
    "quoteUnavailable": "Tạm thời không lấy được báo giá",
    "wechatBrowserGuide": "WeChat H5 Pay phải mở trong trình duyệt điện thoại. Hãy chọn Mở trong trình duyệt.",
    "noPaymentChannels": "Không có phương thức thanh toán đã cấu hình cho khu vực này",
    "continuePayment": "Tiếp tục thanh toán an toàn",
    "checkoutOpening": "Đang mở trang thanh toán…",
    "externalPaymentBlocked": "Trình duyệt đã chặn trang thanh toán. Hãy dùng nút bên dưới để tiếp tục trên trang web bên ngoài.",
    "openExternalPayment": "Mở trang thanh toán bên ngoài",
    "paymentDemo": "Thông báo chế độ thanh toán cũ không còn được sử dụng.",
    "rechargeSuccess": "{amount} xu đã được cộng",
    "emptyOrders": "Không có lệnh nạp tiền",
    "currentAvatar": "Hình đại diện hiện tại",
    "approvedAvatars": "Chọn avatar nền tảng, hoặc chạm vào avatar hiện tại của bạn ở trên để chụp hoặc chọn ảnh",
    "chooseFromAlbum": "Chọn từ ảnh",
    "avatarUploading": "Tải avatar lên",
    "avatarUploadTip": "JPEG, PNG hoặc WebP, dung lượng lên đến 5MB",
    "avatarUploaded": "Avatar đã được tải lên. Lưu hồ sơ của bạn để áp dụng.",
    "avatarOption": "Tùy chọn Avatar",
    "visibleToOthers": "Người dùng khác có thể xem thông tin này",
    "nickname": "Biệt danh",
    "bio": "Tiểu sử",
    "genderTitleHint": "Chỉ dùng cho tiêu đề cấp độ",
    "genderUnset": "Ẩn",
    "genderMale": "Nam",
    "genderFemale": "Nữ",
    "genderRule": "Bạn có thể thay đổi điều này bất cứ lúc nào; Nó sẽ cập nhật tiêu đề cấp độ của bạn sau khi lưu.",
    "saveProfile": "Lưu hồ sơ",
    "opening": "Hồ sơ khai trương",
    "introLabel": "Tuyên bố đăng ký",
    "introPlaceholder": "Mô tả hướng đi, kinh nghiệm và kế hoạch của bạn (20–500 ký tự)",
    "materialsLabel": "Vật liệu hỗ trợ",
    "materialsPlaceholder": "Liên kết công việc, tài khoản xã hội hoặc các thông tin hỗ trợ khác",
    "submitReview": "Gửi để xem xét",
    "removeHistoryConfirm": "Xóa bản ghi đồng hồ này à?",
    "clearHistoryConfirm": "Xóa hết lịch sử đồng hồ? Điều này không thể đảo ngược.",
    "equipSuccess": "Trang bị thành công",
    "reviewing": "Đang được xem xét",
    "roleApproved": "Vai trò này đã được phê duyệt",
    "enabled": "Đã bật",
    "approved": "Được phê duyệt",
    "rejected": "bị từ chối",
    "applyNow": "Nộp đơn",
    "rejectionReason": "Lý do từ chối: {reason}",
    "incompleteMaterials": "Thông tin không đầy đủ",
    "creatorSummary": "Xuất bản video ngắn và quản lý nội dung độc quyền",
    "streamerSummary": "Hãy live, tương tác và nhận quà",
    "applicationSubmitted": "Nộp đơn đăng ký",
    "selectPayment": "Chọn phương thức thanh toán",
    "demoOrderNotice": "Đây là đơn đặt hàng demo. Không tính phí thanh toán và không có đồng xu nào được thêm vào.",
    "demoOrderCreated": "Đơn hàng demo đã được tạo",
    "gotIt": "Hiểu rồi",
    "orderPending": "Đang chờ thanh toán",
    "orderProcessing": "Xử lý",
    "orderCredited": "được ghi nhận",
    "orderFailed": "Thất bại",
    "orderCanceled": "đã hủy",
    "orderExpired": "Đã hết hạn",
    "unknown": "Không rõ",
    "logoutConfirm": "Đăng xuất khỏi tài khoản này?",
    "customAvailable": "Số tiền tùy chỉnh",
    "customAmount": "Số tiền nạp lại tùy chỉnh",
    "customAmountPlaceholder": "Nhập 1.00–10.000.00",
    "customAmountRange": "USD {minimum}–{maximum}, tối đa hai chữ số thập phân",
    "estimatedCoins": "Tiền xu ước tính",
    "invalidRechargeAmount": "Nhập số tiền hợp lệ từ USD {minimum} đến {maximum}, với tối đa hai chữ số thập phân"
  },
  "discoverDetail": {
    "networkTip": "Đài truyền hình đang tạm nghỉ. Vui lòng thử lại trong thời gian ngắn.",
    "searchPlaceholder": "Tìm kiếm phim, tiểu thuyết, nhạc hoặc trò chơi nhỏ",
    "hotBadge": "NÓNG",
    "trendingBadge": "XU HƯỚNG",
    "noResults": "Không có nội dung phù hợp",
    "tryKeyword": "Hãy thử một từ khóa khác",
    "playFirst": "Phát tập 1",
    "previousEpisode": "Tập trước",
    "nextEpisode": "Tập tiếp theo",
    "previousChannel": "Chuyển sang kênh Khám phá trước",
    "nextChannel": "Chuyển sang kênh Khám phá tiếp theo",
    "wordCount": "{count} từ",
    "readerCount": "{count} độc giả",
    "onBookshelf": "Trên giá sách",
    "addBookshelf": "Thêm vào giá sách",
    "startReading": "Bắt đầu đọc",
    "chapterNo": "Chương {no}",
    "noChapters": "Chưa có chương nào",
    "loadMoreChapters": "Tải thêm chương",
    "previousChapter": "Chương trước",
    "nextChapter": "Chương tiếp theo",
    "channelUpdated": "Kênh được cập nhật",
    "localAdded": "Đã thêm vào kệ sách địa phương của bạn",
    "localRemoved": "Đã gỡ bỏ khỏi kệ sách địa phương của bạn",
    "searchRequired": "Nhập từ khóa tìm kiếm",
    "shelfCount": "{count} tiểu thuyết trên giá sách của bạn",
    "continueHint": "Xem, đọc, nghe hoặc chơi để tiếp tục tại đây.",
    "lessRecommendations": "Bạn sẽ thấy ít đề xuất như thế này hơn"
  },
  "discoverLibrary": {
    "title": "Thư viện của tôi",
    "clearAll": "Xóa sạch toàn bộ lịch sử",
    "deleteRecord": "Xóa bản ghi",
    "notStarted": "Chưa bắt đầu",
    "emptyHistory": "Chưa có bản ghi tiếp tục nào",
    "emptyHistoryHint": "Tiến trình kịch bản, tiểu thuyết, âm nhạc và trò chơi của bạn sẽ hiển thị tại đây.",
    "emptyShelf": "Giá sách của bạn trống rỗng",
    "emptyShelfHint": "Hãy để dành tiểu thuyết để tiếp tục đọc sau.",
    "emptyMusicFavorites": "Chưa có nhạc yêu thích",
    "emptyMusicFavoritesHint": "Các bản nhạc yêu thích trong Music để tiếp tục nghe tại đây.",
    "emptyGameFavorites": "Chưa có trò chơi yêu thích nào",
    "emptyGameFavoritesHint": "Những trò chơi nhỏ yêu thích để tiếp tục chơi ở đây.",
    "loadMore": "Tải thêm",
    "deleteConfirm": "Xóa bản ghi xem này?",
    "clearConfirm": "Xóa hết các bản ghi tiếp tục? Điều này không thể đảo ngược.",
    "removeShelfConfirm": "Xóa \"{title}\" khỏi giá sách của bạn?",
    "deleted": "Bản ghi đã bị xóa",
    "cleared": "Lịch sử đã được giải phóng"
  },
  "discoverSearchTerms": {
    "one": "Đám cưới chớp nhoáng",
    "two": "Sự trở lại",
    "three": "Bí ẩn",
    "four": "ngày tận thế",
    "five": "Chữa lành",
    "six": "Lãng mạn lịch sử"
  },
  "appUi": {
    "login": "Đăng nhập",
    "register": "Đăng ký",
    "backLogin": "Quay lại đăng nhập",
    "email": "Email",
    "account": "Tên người dùng hoặc email",
    "accountPlaceholder": "Nhập tên người dùng hoặc email",
    "accountRequired": "Vui lòng nhập tên người dùng hoặc email",
    "passwordLogin": "Mật khẩu",
    "codeLogin": "Mã email",
    "code": "Mã xác minh",
    "codePlaceholder": "Mã 6 chữ số",
    "getCode": "Nhận mã",
    "newPassword": "Mật khẩu mới",
    "password": "Mật khẩu",
    "passwordPlaceholder": "8–72 ký tự có chữ cái và số",
    "confirmPassword": "Xác nhận mật khẩu",
    "confirmPasswordPlaceholder": "Nhập lại mật khẩu",
    "forgotPassword": "Quên hoặc chưa đặt mật khẩu?",
    "agreeTerms": "Đồng ý với Điều khoản Dịch vụ",
    "agreePrivacy": "Đồng ý với Chính sách Bảo mật",
    "remember": "Giữ cho tôi được đăng nhập",
    "reply": "Trả lời",
    "delete": "Xóa",
    "report": "Báo cáo",
    "block": "Block",
    "noComments": "Chưa có bình luận nào. Hãy là người đầu tiên tham gia vào cuộc trò chuyện.",
    "replyTo": "Trả lời {name}",
    "replyPlaceholder": "Trả lời {name}...",
    "commentPlaceholder": "Hãy để lại bình luận...",
    "send": "Gửi",
    "blockedTapUndo": "Bị chặn · Nhấn để hoàn tác",
    "unblock": "Bỏ chặn",
    "blockAuthor": "Trình tạo khối",
    "reportAccount": "Báo cáo tài khoản",
    "works": "Tác phẩm",
    "exclusive": "Độc quyền",
    "liveNow": "Trực tiếp ngay bây giờ",
    "replay": "Trận đấu lại",
    "worksEmptyTip": "Các tác phẩm mới của tác giả này sẽ xuất hiện tại đây.",
    "loadingMore": "Đang tải...",
    "loadMoreWorks": "Tải thêm tác phẩm",
    "paidAlbum": "Album trả phí",
    "paidVideo": "Video trả phí",
    "purchased": "Đã mua",
    "coinPrice": "{amount} đồng xu",
    "noPremiumTip": "Người sáng tạo này chưa xuất bản album hoặc video trả phí.",
    "notInterested": "Không quan tâm",
    "lessSimilar": "Hiển thị ít đề xuất tương tự hơn",
    "blockAuthorTip": "Ẩn nội dung của người sáng tạo này và hạn chế tương tác",
    "reportContent": "Nội dung báo cáo",
    "reportContentTip": "Thêm lý do và bằng chứng hỗ trợ",
    "reasonSpam": "Thư rác hoặc quảng cáo",
    "reasonIllegal": "Nội dung bất hợp pháp",
    "reasonInfringement": "Vi phạm bản quyền",
    "reasonViolence": "Bạo lực hoặc nội dung gây khó chịu",
    "reasonOther": "Khác",
    "reportDetailPlaceholder": "Chi tiết bổ sung (tùy chọn)",
    "reportEvidencePlaceholder": "Văn bản bằng chứng hoặc liên kết HTTPS (tùy chọn)",
    "submitReport": "Gửi báo cáo",
    "systemShare": "Chia sẻ hệ thống",
    "copyLink": "Sao chép liên kết",
    "internalShare": "Chia sẻ trong ứng dụng",
    "shareChannelNote": "Các dịch vụ cụ thể như WeChat và QQ sẽ được thêm vào sau khi khả năng nền tảng của chúng được xác nhận.",
    "reviewNote": "Chúng tôi sẽ xem xét hồ sơ của bạn sớm. Hãy theo dõi các cập nhật.",
    "creatorIntro": "Khi được duyệt, bạn có thể đăng video ngắn và bắt đầu phát trực tiếp. Hãy kể cho chúng tôi về hướng đi nội dung của bạn.",
    "creatorPlaceholder": "Ví dụ: hướng dẫn chụp ảnh và quay phim vào ban đêm thành phố",
    "submitApplication": "Nộp đơn đăng ký",
    "tipTo": "Hỗ trợ {name}",
    "currentBalance": "Cán cân vãng lai: {amount} đồng xu",
    "confirmTipPay": "Xác nhận thanh toán và hỗ trợ",
    "albumImageAlt": "{title}, hình ảnh {index}",
    "albumImageCaption": "Hình ảnh {index}",
    "purchasedVisible": "Đã mua và có sẵn cho tài khoản này",
    "purchaseAccessIssue": "Có sự cố tạm thời với quyền truy cập mua hàng của bạn",
    "contactSupport": "Liên hệ bộ phận hỗ trợ để kiểm tra trạng thái quyền lợi",
    "payToUnlock": "Trả {amount} xu để mở khóa",
    "totalSpent": "Tổng chi tiêu: {amount} đồng xu",
    "balanceAfter": "Số dư {amount}",
    "noTransactions": "Chưa có giao dịch nào",
    "viewContent": "Xem nội dung",
    "delistedAccessible": "Đã hủy niêm yết · Vẫn có thể truy cập",
    "noPurchases": "Chưa có mua hàng nào",
    "emailRequired": "Nhập email của bạn",
    "emailInvalid": "Nhập địa chỉ email hợp lệ",
    "joinStarLive": "Tham gia StarLive",
    "setNewPassword": "Đặt mật khẩu mới",
    "loginToContinue": "Đăng nhập để tiếp tục",
    "verifyByEmail": "Xác minh danh tính của bạn bằng mã email",
    "createPasswordOrCode": "Tạo mật khẩu hoặc đăng nhập bằng mã email",
    "safePasswordLogin": "Đăng nhập an toàn bằng email và mật khẩu của bạn",
    "safeCodeLogin": "Đăng nhập an toàn bằng mã email",
    "registerExplore": "Đăng ký và bắt đầu khám phá",
    "setPasswordLogin": "Đặt mật khẩu và đăng nhập",
    "loginContinue": "Đăng nhập và tiếp tục",
    "creatorReviewing": "Đang được xem xét",
    "creatorApproved": "Quyền truy cập của người sáng tạo được cấp",
    "creatorRejected": "Đơn đăng ký bị từ chối",
    "statusPending": "Tình trạng đang chờ xử lý",
    "contentDelisted": "Nội dung đã bị gỡ bỏ",
    "commentUnavailable": "Bình luận này đã bị xóa hoặc không còn khả dụng.",
    "deleteCommentConfirm": "Việc xóa không thể hoàn tác. Xóa bình luận này à?",
    "deleteComment": "Xóa bình luận",
    "blockUserConfirm": "Chặn {name}? Bình luận của họ sẽ bị ẩn và các tương tác sẽ bị hạn chế.",
    "confirmBlock": "Xác nhận chặn",
    "userBlocked": "Người dùng bị chặn",
    "systemShareUnsupported": "Chia sẻ hệ thống không khả dụng trong trình duyệt này. Thay vào đó, hãy sử dụng Sao chép liên kết.",
    "copyFailed": "Không sao chép được liên kết. Sao chép địa chỉ trình duyệt thủ công.",
    "internalShared": "Chia sẻ vào tin nhắn trong ứng dụng",
    "linkCopied": "Đã sao chép liên kết",
    "shareSuccess": "Chia sẻ thành công",
    "authorBlocked": "Người tạo bị chặn",
    "authorUnblocked": "Người tạo đã được mở khóa",
    "blockAuthorConfirm": "Việc chặn sẽ ẩn tác phẩm của người sáng tạo này và bỏ theo dõi họ.",
    "blockNamedAuthorConfirm": "Chặn {name}? Tất cả tác phẩm của họ sẽ bị giấu kín.",
    "creatorMinLength": "Nhập ít nhất 10 ký tự về nội dung của bạn.",
    "tipConfirm": "Trả {amount} xu để hỗ trợ \"{title}\"?",
    "coinPaymentConfirm": "Xác nhận thanh toán bằng tiền xu",
    "confirmPayment": "Xác nhận thanh toán",
    "purchaseConfirm": "Trả {amount} xu để mua \"{title}\"?",
    "confirmPurchase": "Xác nhận mua hàng",
    "loggedOut": "Đăng xuất",
    "codeInvalid": "Nhập mã xác minh 6 chữ số",
    "passwordInvalid": "Mật khẩu phải dài từ 8–72 ký tự và bao gồm chữ cái và số.",
    "passwordMismatch": "Mật khẩu không khớp nhau.",
    "agreementRequired": "Hãy đồng ý với Điều khoản Dịch vụ và Chính sách Bảo mật trước."
  },
  "studioUi": {
    "title": "Creator Studio",
    "workspace": "Không gian làm việc của bạn",
    "notActivated": "Quyền truy cập của người sáng tạo chưa được bật",
    "heroDescription": "Quản lý video ngắn, phòng trực tiếp và xem lại tiến trình.",
    "totalWorks": "các vật phẩm",
    "shortVideo": "Truy cập video ngắn",
    "liveRoom": "Phòng trực tiếp",
    "enabled": "Đã bật",
    "applyCreator": "Đăng ký làm người sáng tạo",
    "applyStreamer": "Đăng ký làm chủ nhà",
    "shortVideos": "Video ngắn",
    "liveRooms": "Phòng trực tiếp",
    "publishVideo": "Xuất bản video ngắn",
    "createLive": "Tạo phòng trực tiếp",
    "applyCreatorAction": "Đăng ký với tư cách người sáng tạo để xuất bản",
    "applyStreamerAction": "Đăng ký làm chủ nhà để phát sóng trực tiếp",
    "liveNow": "TRỰC TIẾP",
    "rejectReason": "Lý do từ chối: {reason}",
    "noReason": "Cập nhật nội dung và gửi lại",
    "edit": "Chỉnh sửa",
    "submitReview": "Gửi để xem xét",
    "hide": "Hủy xuất bản",
    "republish": "Xuất bản lại",
    "startLive": "Phát trực tiếp",
    "endLive": "Kết thúc trực tiếp",
    "delete": "Xóa",
    "loadingMore": "Đang tải...",
    "loadMore": "Tải thêm",
    "noVideos": "Chưa có video ngắn nào",
    "noLiveRooms": "Chưa có phòng trực tiếp nào",
    "emptyTip": "Lưu bản thảo đầu tiên của bạn. Nó sẽ xuất hiện sau khi được phê duyệt.",
    "editWork": "Chỉnh sửa nội dung",
    "newWork": "Nội dung mới",
    "sampleAssets": "Tài sản mẫu",
    "chooseVideo": "Chọn video từ thiết bị",
    "uploadingVideo": "Tải video lên",
    "videoUploadTip": "MP4, WebM hoặc MOV, dung lượng lên đến 120MB",
    "videoUploaded": "Video đã được tải lên",
    "chooseCover": "Chọn bìa video",
    "uploadingCover": "Tải lên bìa",
    "coverUploadTip": "JPEG, PNG hoặc WebP, tối đa 10MB",
    "coverUploaded": "Bìa video đã được tải lên",
    "discoveryMusic": "Khám phá âm nhạc",
    "chooseMusic": "Chọn nhạc nền tùy chọn",
    "workTitle": "Tiêu đề",
    "titlePlaceholder": "Tóm tắt nội dung trong một dòng",
    "description": "Mô tả",
    "descriptionPlaceholder": "Mô tả những điểm nổi bật và lý do tại sao mọi người nên xem",
    "tags": "Thẻ",
    "tagsPlaceholder": "Thẻ riêng biệt với dấu phẩy",
    "playUrl": "URL phát lại",
    "coverUrl": "URL bìa",
    "duration": "Thời lượng (giây)",
    "visibility": "Tầm nhìn",
    "public": "Công chúng",
    "loginOnly": "Người dùng đã đăng nhập",
    "private": "Riêng tư",
    "liveSourceTip": "Nhập ID TikTok để phát trực tiếp. Bìa TikTok live được nhập tự động; Không cần bản nháp phòng hay đánh giá lại.",
    "reviewTip": "Sau khi gửi, nội dung không thể chỉnh sửa cho đến khi hoàn tất việc xem xét.",
    "saveDraft": "Lưu bản nháp",
    "saving": "Tiết kiệm...",
    "saveAndSubmit": "Lưu & gửi",
    "requiredTip": "Nhập tiêu đề và thông tin cần thiết",
    "submitted": "Đã nộp để xem xét",
    "draftSaved": "Bản nháp đã lưu",
    "submitConfirm": "Bạn không thể chỉnh sửa khi đang chờ xem xét. Tiếp tục à?",
    "republished": "Tác phẩm được tái bản",
    "hidden": "Tác phẩm chưa xuất bản",
    "startLiveConfirm": "Bắt đầu phòng phát trực tiếp với URL phát lại này?",
    "liveStarted": "Bắt đầu phát trực tiếp",
    "liveEnded": "Buổi phát trực tiếp kết thúc",
    "deleteConfirm": "Xóa bản nháp này? Điều này không thể đảo ngược.",
    "deleted": "Bản nháp đã bị xóa",
    "draft": "Bản nháp",
    "pending": "Đang chờ xử lý",
    "approved": "Được phê duyệt",
    "rejected": "bị từ chối",
    "readyToLive": "Sẵn sàng ra mắt",
    "published": "Đã xuất bản",
    "unpublished": "Chưa xuất bản",
    "notificationSubmittedTitle": "Nội dung đã nộp",
    "notificationSubmittedContent": "Nội dung của bạn hiện đã nằm trong hàng đợi xem xét.",
    "notificationApprovedTitle": "Nội dung đã được phê duyệt",
    "notificationApprovedContent": "Nội dung của bạn đã được phê duyệt. Quản lý nó trong Creator Studio.",
    "notificationRejectedTitle": "Nội dung chưa được phê duyệt",
    "notificationRejectedContent": "Mở Creator Studio để xem lý do, chỉnh sửa và gửi lại.",
    "stopLive": "Kết thúc trực tiếp",
    "tiktokStartTitle": "Kết nối TikTok Live",
    "tiktokStartDescription": "Nhập ID TikTok. Khi TikTok được xác nhận phát sóng trực tiếp, StarLive sẽ nhập bản cover trực tiếp và bắt đầu phiên làm việc ngay lập tức mà không cần xem lại.",
    "liveAlreadyActive": "Trực tiếp ngay bây giờ",
    "tiktokId": "TikTok ID",
    "tiktokIdPlaceholder": "Ví dụ: starlive_host",
    "tiktokStartTip": "StarLive nhập bìa TikTok live, tiêu đề và luồng trực tiếp. Trạng thái hoạt động sẽ không thay đổi nếu tài khoản đang ngoại tuyến.",
    "tiktokChecking": "Đang kiểm tra trạng thái hoạt động...",
    "confirmStartLive": "Xác minh & lên mạng"
  },
  "notificationUi": {
    "markAllRead": "Đánh dấu tất cả đã đọc",
    "loading": "Đang tải tin nhắn",
    "loadingMore": "Đang tải...",
    "viewMore": "Xem thêm tin nhắn",
    "settingsIntro": "Quản lý thông báo trong ứng dụng và đẩy theo loại. Các kết quả quan trọng về giao dịch và bảo mật tài khoản vẫn còn trong đơn hàng hoặc hồ sơ tài khoản của bạn.",
    "messageType": "Loại tin nhắn",
    "inApp": "Trong ứng dụng",
    "push": "Đẩy",
    "saveSettings": "Lưu cài đặt",
    "all": "Tất cả",
    "interaction": "Tương tác",
    "live": "Trực tiếp",
    "transaction": "Giao dịch",
    "review": "Đánh giá",
    "system": "Hệ thống",
    "confirmAll": "Đánh dấu tất cả tin nhắn là đã đọc?",
    "confirmCategory": "Đánh dấu mọi tin nhắn trong danh mục này là đã đọc?",
    "pushAvailable": "Thông báo đẩy có sẵn trên thiết bị này.",
    "pushUnavailable": "Thông báo đẩy không khả dụng trên thiết bị này. Tin nhắn trong ứng dụng không bị ảnh hưởng.",
    "settingsSaved": "Cài đặt thông báo đã lưu",
    "backToInbox": "Quay lại hộp thư đến",
    "backToConversations": "Quay lại tin nhắn",
    "systemNotice": "Thông báo hệ thống",
    "officialSource": "Chính thức StarLive",
    "officialInbox": "Tin nhắn chính thức StarLive",
    "officialVerified": "Được nền tảng xác minh · người dùng không thể tạo danh tính này",
    "officialInboxEmpty": "Thông báo nền tảng và tài khoản sẽ xuất hiện tại đây",
    "noticeReference": "Tin nhắn #{id}"
  },
  "notificationEvent": {
    "someone": "Ai đó",
    "comment_reply": {
      "title": "Bình luận của bạn đã nhận được phản hồi",
      "content": "{actor} đã trả lời bình luận của bạn."
    },
    "reply": {
      "title": "Bình luận của bạn đã nhận được phản hồi",
      "content": "{actor} đã trả lời bình luận của bạn."
    },
    "like": {
      "title": "Có người thích tác phẩm của bạn",
      "content": "{actor} thích video ngắn của bạn."
    },
    "follow": {
      "title": "Bạn có người theo dõi mới",
      "content": "{actor} đã theo dõi bạn."
    },
    "live_started": {
      "title": "Một nhà sáng tạo bạn theo dõi đang hoạt động",
      "content": "{actor} đang hoạt động. Nhấn để vào luồng phát trực tiếp."
    },
    "reservation_reminder": {
      "title": "Một buổi phát trực tiếp theo lịch trình sẽ bắt đầu sớm",
      "content": "Một buổi phát trực tiếp bạn đã đặt sắp bắt đầu."
    },
    "purchase_success": {
      "title": "Nội dung độc quyền đã mua",
      "content": "Nội dung đã được mở khóa và đã được thêm vào các giao dịch mua của bạn."
    },
    "tip_success": {
      "title": "Hỗ trợ được gửi thành công",
      "content": "Việc hỗ trợ coin của bạn đã hoàn tất và ghi nhận trong các giao dịch."
    },
    "recharge_order_created": {
      "title": "Đã tạo lệnh nạp tiền",
      "content": "Lệnh đã được thành lập. Kiểm tra trạng thái thanh toán trong Ví."
    },
    "recharge_success": {
      "title": "Đã nạp tiền",
      "content": "Các đồng coin đã được thêm vào ví của bạn và sẵn sàng sử dụng."
    },
    "order_abnormal": {
      "title": "Thứ tự nạp lại cần được chú ý",
      "content": "Lệnh nạp tiền có vấn đề. Mở đơn hàng để xem lại hoặc thử lại."
    },
    "creator_application_submitted": {
      "title": "Đơn đăng ký của người sáng tạo đã gửi",
      "content": "Đơn của bạn đã vào hàng đợi xem xét. Chúng tôi sẽ thông báo cho bạn tại đây khi có thay đổi."
    },
    "creator_review": {
      "title": "Đã nhận được đơn của người sáng tạo",
      "content": "Đơn của bạn đang được xem xét. Kết quả sẽ xuất hiện trong hộp thư đến của bạn."
    },
    "rule_update": {
      "title": "Quy định cộng đồng được cập nhật",
      "content": "Quy định của sân ga đã thay đổi. Xem lại phiên bản mới nhất."
    },
    "security": {
      "title": "Cảnh báo bảo mật tài khoản",
      "content": "Hoạt động tài khoản mới đã được phát hiện. Hãy kiểm tra cài đặt bảo mật nếu không phải do bạn."
    },
    "security_email_changed": {
      "title": "Email tài khoản đã thay đổi",
      "content": "Email của bạn đã được cập nhật và các thiết bị khác đã đăng xuất."
    },
    "security_password_changed": {
      "title": "Mật khẩu tài khoản đã thay đổi",
      "content": "Mật khẩu của bạn đã được cập nhật và các thiết bị khác đã được đăng xuất."
    }
  },
  "searchUi": {
    "placeholder": "Tìm kiếm người dùng, video ngắn hoặc phát trực tiếp",
    "heat": "{count} độ phổ biến",
    "all": "Tất cả",
    "searchingFor": "Đang tìm kiếm \"{keyword}\"",
    "followers": "{count} người theo dõi",
    "liveNow": "Trực tiếp ngay bây giờ",
    "livePreview": "Xem trước trực tiếp",
    "views": "{count} lượt xem",
    "plays": "{count} vang lên",
    "loadFailed": "Tìm kiếm thất bại",
    "loadFailedTip": "Vui lòng kiểm tra kết nối và thử lại",
    "retry": "Thử lại",
    "loadingMore": "Đang tải",
    "loadMore": "Xem thêm",
    "endOfResults": "Không còn kết quả"
  },
  "errors": {
    "AUTH.REQUIRED": "Vui lòng đăng nhập trước.",
    "AUTH.FORBIDDEN": "Bạn không có quyền cho hành động này.",
    "AUTH.CREATOR_REQUIRED": "Nộp đơn xin quyền truy cập tác giả trước.",
    "AUTH.STREAMER_REQUIRED": "Hãy nộp đơn xin quyền truy cập chủ nhà trước.",
    "COMMON.NOT_FOUND": "Nội dung này không khả dụng.",
    "COMMON.CONFLICT": "Dữ liệu đã thay đổi. Làm mới và thử lại.",
    "COMMON.VALIDATION_FAILED": "Vui lòng kiểm tra thông tin đã gửi.",
    "COMMON.RATE_LIMITED": "Quá nhiều yêu cầu. Vui lòng thử lại sau.",
    "COMMON.REQUEST_FAILED": "Yêu cầu thất bại. Vui lòng thử lại.",
    "COMMON.SYSTEM_ERROR": "Đã xảy ra lỗi hệ thống. Vui lòng thử lại sau.",
    "WALLET.INSUFFICIENT_BALANCE": "Số dư đồng xu không đủ. Xin hãy nạp lại năng lượng trước.",
    "PAYMENT.CHANNEL_NOT_CONFIGURED": "Phương thức thanh toán này chưa được cấu hình.",
    "PAYMENT.ORDER_CREATING": "Đơn thanh toán đang được tạo. Vui lòng không gửi lại.",
    "PAYMENT.WECHAT_MERCHANT_AUTH_FAILED": "Xác minh thương nhân WeChat Pay thất bại. Hãy thử lại sau hoặc chọn phương thức khác.",
    "PAYMENT.ALIPAY_MERCHANT_CONFIG_FAILED": "Cấu hình thương nhân Alipay tạm thời không khả dụng. Hãy thử lại sau hoặc chọn phương thức khác.",
    "PAYMENT.PAYPAL_MERCHANT_AUTH_FAILED": "Xác minh thương nhân PayPal thất bại. Hãy thử lại sau hoặc chọn phương thức khác.",
    "PAYMENT.PROVIDER_TEMPORARILY_UNAVAILABLE": "Dịch vụ thanh toán tạm thời không khả dụng. Hãy thử lại sau hoặc chọn phương thức khác.",
    "GAME.NOT_AVAILABLE": "Trò chơi nhỏ này tạm thời không khả dụng.",
    "GAME.EXTERNAL_NOT_ALLOWED": "URL trò chơi bên ngoài không vượt qua kiểm tra bảo mật.",
    "CONTENT.PURCHASE_UNAVAILABLE": "Hiện chưa có thể mua nội dung này.",
    "CONTENT.INVALID_ASSET_URL": "URL phát lại hoặc bìa không hợp lệ.",
    "CONTENT.INVALID_ASSET_COUNT": "Video trả phí yêu cầu đúng một video; Album có thể chứa tối đa 20 hình ảnh.",
    "CONTENT.MUSIC_NOT_AVAILABLE": "Bản nhạc đã chọn không khả dụng trong khu vực của bạn.",
    "PROFILE.INVALID_AVATAR": "Chọn avatar nền tảng hoặc avatar được tải lên bởi tài khoản này.",
    "PROFILE.APPLICATION_INTRO_LENGTH": "Câu lệnh đăng ký phải dài từ 20–500 ký tự.",
    "UPLOAD.INVALID_SCENE": "Loại tải lên này không được hỗ trợ.",
    "UPLOAD.FILE_REQUIRED": "Chọn một tệp để tải lên.",
    "UPLOAD.VIDEO_TOO_LARGE": "Video không được lớn hơn 120MB.",
    "UPLOAD.IMAGE_TOO_LARGE": "Hình ảnh vượt quá giới hạn kích thước.",
    "UPLOAD.INVALID_VIDEO": "Chỉ hỗ trợ video MP4, WebM hoặc MOV.",
    "UPLOAD.INVALID_IMAGE": "Chỉ hỗ trợ hình ảnh JPEG, PNG hoặc WebP.",
    "UPLOAD.SAVE_FAILED": "Không thể lưu lại tập tin. Thử lại sau.",
    "CONTENT.AUTHOR_CREATE_FAILED": "Không thể tạo hồ sơ người tạo.",
    "CONTENT.NOT_EDITABLE": "Nội dung đang chờ xử lý hoặc đã được phê duyệt không thể chỉnh sửa.",
    "CONTENT.TYPE_IMMUTABLE": "Loại nội dung không thể thay đổi.",
    "CONTENT.REVIEW_PENDING": "Nội dung này hiện đang được xem xét.",
    "CONTENT.NOT_APPROVED": "Nội dung này chưa được phê duyệt.",
    "CONTENT.LIVE_NOT_APPROVED": "Phòng trực tiếp này chưa được phê duyệt.",
    "CONTENT.NOT_DELETABLE": "Mục này không thể bị xóa ở trạng thái hiện tại.",
    "CONTENT.COMMENTS_DISABLED": "Các bình luận và phản hồi mới sẽ bị tắt cho tác phẩm này.",
    "COMMENT.NOT_FOUND": "Bình luận này không khả dụng.",
    "COMMENT.DELETE_FORBIDDEN": "Bạn không thể xóa bình luận này.",
    "DECORATION.INVALID_TYPE": "Loại mục kiểu này không hợp lệ.",
    "DECORATION.INVALID_SORT": "Thứ tự sắp xếp kiểu này không hợp lệ.",
    "DECORATION.NOT_FOUND": "Mặt hàng kiểu này không khả dụng.",
    "DECORATION.ALREADY_OWNED": "Bạn đã sở hữu món đồ kiểu này rồi.",
    "DECORATION.NOT_OWNED": "Bạn chưa sở hữu món đồ thời trang này.",
    "DECORATION.PURCHASED": "Mua hàng thành công.",
    "DECORATION.EQUIPPED": "Trang bị vật phẩm phong cách.",
    "QR_LOGIN.INVALID_CLIENT": "Ứng dụng đồng hành không thể xác thực.",
    "QR_LOGIN.TOO_MANY_ACTIVE": "Quá nhiều yêu cầu đăng nhập qua QR đang chờ xử lý. Hãy thử lại ngay sau đây.",
    "QR_LOGIN.INVALID_TICKET": "Mã QR đăng nhập này không hợp lệ hoặc không còn khả dụng.",
    "QR_LOGIN.EXPIRED": "Mã QR đăng nhập này đã hết hạn. Tạo một thiết bị mới trên thiết bị kia.",
    "QR_LOGIN.NOT_PENDING": "Yêu cầu đăng nhập này đã được xử lý. Tạo mã QR mới.",
    "QR_LOGIN.DENIED": "Yêu cầu đăng nhập này đã bị từ chối.",
    "QR_LOGIN.CONSUMED": "Giấy phép này đã được sử dụng và không thể tái sử dụng.",
    "QR_LOGIN.NOT_APPROVED": "Quét và phê duyệt yêu cầu này bằng tài khoản streamer StarLive trước.",
    "CONTENT.PLAY_URL_REQUIRED": "Nhập URL phát lại cho video ngắn.",
    "LIVE.INVALID_TIKTOK_ID": "Sử dụng 2–24 chữ cái, số, dấu gạch dưới hoặc dấu chấm cho TikTok ID.",
    "LIVE.INVALID_GAME_URL": "URL trò chơi tương tác phải là một trang HTTPS hợp lệ.",
    "LIVE.ALREADY_ACTIVE": "Bạn đã có một phiên trực tiếp đang hoạt động. Hãy kết thúc trước khi bắt đầu lần khác.",
    "LIVE.DIRECT_START_ONLY": "Phiên trực tiếp không sử dụng bản nháp. Nhập ID TikTok để phát trực tiếp.",
    "LIVE.TIKTOK_NOT_LIVE": "ID TikTok này không còn hoạt động. Hãy bắt đầu phát trực tiếp trên TikTok trước.",
    "LIVE.TIKTOK_UPSTREAM_UNAVAILABLE": "Hiện tại TikTok không thể truy cập được. Thử lại sau.",
    "LIVE.STREAM_NOT_FOUND": "Phòng đang phát trực tiếp, nhưng hiện tại chưa có phát trực tiếp có thể phát được.",
    "LIVE.REALTIME_UNAVAILABLE": "Tương tác trực tiếp tạm thời không thể kết nối theo thời gian thực; hệ thống đang đồng bộ với tần suất thấp.",
    "LIVE.ENDED": "Phiên trực tiếp này đã kết thúc.",
    "LIVE.CHAT_SENSITIVE": "Thông báo này chứa nội dung bị hạn chế. Chỉnh sửa rồi thử lại.",
    "WALLET.INVALID_RECHARGE_AMOUNT": "Nhập số tiền nạp lại hợp lệ từ 1,00 đến 10.000,00 USD, với tối đa hai chữ số thập phân.",
    "CENTER.FANS_PERMISSION_REQUIRED": "Yêu cầu quyền truy cập của người sáng tạo hoặc chủ nhà để xem người theo dõi.",
    "CENTER.FAN_NOT_FOUND": "Mối quan hệ người theo dõi này không khả dụng.",
    "SECURITY.INVALID_SCENE": "Yêu cầu xác minh này không hợp lệ",
    "SECURITY.INVALID_EMAIL": "Nhập địa chỉ email hợp lệ",
    "SECURITY.SAME_EMAIL": "Email mới phải khác với email hiện tại của bạn",
    "SECURITY.EMAIL_IN_USE": "Email này đã được liên kết với một tài khoản khác",
    "SECURITY.CODE_RATE_LIMITED": "Quá nhiều yêu cầu mã. Thử lại sau",
    "SECURITY.CODE_SEND_FAILED": "Không thể gửi mã xác minh",
    "SECURITY.CODE_INVALID": "Mã không chính xác, đã qua sử dụng hoặc hết hạn",
    "SECURITY.PASSWORD_INVALID": "Sử dụng từ 8–72 ký tự với chữ cái và số",
    "SECURITY.PASSWORD_MISMATCH": "Mật khẩu không khớp",
    "SECURITY.PASSWORD_UNCHANGED": "Mật khẩu mới của bạn phải khác",
    "SECURITY.INVALID_SESSION": "Thông tin thiết bị đăng nhập không hợp lệ",
    "SECURITY.CURRENT_SESSION_PROTECTED": "Bạn không thể đăng xuất thiết bị hiện tại từ xa",
    "SECURITY.SESSION_NOT_FOUND": "Thiết bị này đã đăng xuất hoặc không khả dụng",
    "ACCOUNT.EMAIL_BINDING_REQUIRED": "Vui lòng liên kết và xác minh email trước",
    "ACCOUNT.INVALID_USERNAME": "Định dạng tên người dùng không hợp lệ",
    "ACCOUNT.USERNAME_IN_USE": "Tên người dùng này đã được sử dụng",
    "AUTH.INVALID_CREDENTIALS": "Tên người dùng, email hoặc mật khẩu không đúng",
    "AUTH.INVALID_ACCOUNT": "Nhập tên người dùng hoặc email hợp lệ",
    "GAME_WALLET.INVALID_GAME_KEY": "Xác thực trò chơi thất bại",
    "GAME_WALLET.USER_NOT_FOUND": "Không tìm thấy tài khoản streamer",
    "GAME_WALLET.IDEMPOTENCY_CONFLICT": "Mã yêu cầu đã được dùng với tham số khác",
    "GAME_WALLET.WALLET_DISABLED": "Ví trò chơi tương tác đã bị tắt",
    "GAME_WALLET.CREDIT_LIMIT_EXCEEDED": "Đã vượt hạn mức tín dụng của ví trò chơi",
    "GAME_WALLET.INVALID_RECHARGE_AMOUNT": "Nhập số tiền nạp hợp lệ",
    "GAME_WALLET.RECHARGE_CHANNEL_UNAVAILABLE": "Kênh nạp tiền hiện không khả dụng",
    "GUILD.DISABLED": "Hội này đang chờ phê duyệt hoặc bị vô hiệu hóa.",
    "GUILD.CREATOR_ALREADY_JOINED": "Bạn đã thuộc về một bang hội và không thể nhận lời mời khác.",
    "GUILD.REQUEST_PENDING": "Một yêu cầu kiểu này hiện đang được xử lý.",
    "GUILD.MEMBERSHIP_REQUIRED": "Không tìm thấy thành viên hội đang hoạt động.",
    "GUILD.INVALID_TARGET": "Bang hội điểm đến không khả dụng.",
    "GUILD.PERMISSION_DENIED": "Bạn không thể xử lý yêu cầu của bang hội này.",
    "GUILD.SHARE_EXCEEDS_LEVEL": "Phần chia sẻ của người tạo vượt quá mức phân bổ của cấp bang hội này.",
    "GUILD.INVITE_ALREADY_HANDLED": "Lời mời này đã được xử lý hoặc không còn khả dụng. Làm mới để xem trạng thái mới nhất của nó."
  },
  "readerSettings": {
    "title": "Cài đặt đọc",
    "fontSize": "Kích thước phông chữ",
    "decreaseFont": "Giảm kích thước phông chữ",
    "increaseFont": "Tăng kích thước phông chữ",
    "lineSpacing": "Khoảng cách dòng",
    "spacingCompact": "nhỏ gọn",
    "spacingComfortable": "Thoải mái",
    "spacingRelaxed": "thư giãn",
    "background": "Bối cảnh đọc sách",
    "themePaper": "Giấy",
    "themeEye": "Chăm sóc mắt",
    "themeNight": "Ban đêm"
  },
  "audiobookUi": {
    "title": "Sách nói",
    "eyebrow": "SÁCH NÓI STARLIVE",
    "available": "Có sách nói cho chương này",
    "unavailable": "Chương này không có âm thanh sách nói",
    "play": "Phát sách nói",
    "pause": "Tạm dừng sách nói",
    "previous": "Âm thanh chương trước",
    "next": "Âm thanh chương tiếp theo",
    "speed": "Tốc độ phát lại",
    "progress": "Tiến độ sách nói",
    "close": "Đóng bảng sách nói",
    "loadFailed": "Không thể tải được âm thanh sách nói. Thử lại sau."
  },
  "feedDiscovery": {
    "eyebrow": "LỰA CHỌN KHÁM PHÁ STARLIVE",
    "recommendation": "Một lựa chọn thỉnh thoảng từ Discover",
    "heat": "Độ phổ biến {count}",
    "episodeMeta": "Tập {current} của {total}",
    "gameMeta": "Trò chơi nhỏ StarLive",
    "types": {
      "drama": "Phim ngắn",
      "novel": "Tiểu thuyết",
      "music": "Âm nhạc",
      "game": "Trò chơi nhỏ"
    },
    "actions": {
      "drama": "Xem kịch",
      "novel": "Bắt đầu đọc",
      "music": "Nghe ngay",
      "game": "Chơi ngay"
    }
  },
  "decoration": {
    "channel": "Phong cách",
    "shopTitle": "Xưởng Phong cách",
    "shopSubtitle": "Chọn khung hình avatar và hiệu ứng xuất hiện. Mỗi lần mua đều thuộc về bạn vĩnh viễn.",
    "myTitle": "Phong cách của tôi",
    "mySubtitle": "Khung hình, hiệu ứng xuất hiện và lợi ích cấp độ vẫn độc lập. Thay đổi bất cứ lúc nào.",
    "avatarFrames": "Khung hình avatar",
    "floatingScreens": "Hiệu ứng Lối vào",
    "categoryLabel": "Danh mục phong cách",
    "sortLabel": "Sắp xếp",
    "sortRecommended": "Đề xuất",
    "priceLow": "Giá: thấp đến cao",
    "priceHigh": "Giá: cao đến thấp",
    "preview": "Xem trước",
    "previewItem": "Xem trước “{name}”",
    "previewTitle": "Xem trước phong cách",
    "previewHint": "Xem trước phong cách này khi được áp dụng.",
    "closePreview": "Đóng bản xem trước",
    "avatarPreviewAlt": "Avatar của tôi",
    "loadMore": "Tải thêm",
    "loadingMore": "Đang tải",
    "allLoaded": "Đã hiển thị tất cả {count} mục",
    "loadFailed": "Không thể tải sản phẩm phong cách. Hãy thử lại.",
    "retry": "Thử lại",
    "emptyFrameTitle": "Bạn chưa có khung avatar",
    "emptyFrameHint": "Thêm một chút ánh sao cho avatar bằng khung hình phù hợp với bạn.",
    "browseFrames": "Chọn khung avatar",
    "owned": "Sở hữu",
    "inUse": "Đang sử dụng",
    "empty": "Hiện chưa có sản phẩm kiểu dáng nào",
    "equip": "Trang bị",
    "remove": "Tháo trang bị",
    "purchaseTitle": "Xác nhận mua hàng",
    "purchaseConfirm": "Mua \"{name}\" bằng đồng xu {price}? Sản phẩm này sẽ thuộc về bạn vĩnh viễn.",
    "buyNow": "Mua ngay",
    "purchaseSuccess": "\"{name}\" đã được thêm vào Phong cách của tôi",
    "equipSuccess": "Trang bị vật phẩm kiểu dáng",
    "removeSuccess": "Mục kiểu đã bị loại bỏ",
    "liveEntered": "{name} đã nhập theo kiểu",
    "defaultEntrance": "Lối vào StarLive Starlight",
    "levelEntrance": "Lối vào cấp độ StarLive Lv.{level}"
  },
  "qrLogin": {
    "entry": "Quét để đăng nhập",
    "back": "Quay lại hồ sơ",
    "title": "Đăng nhập qua QR",
    "eyebrow": "ĐĂNG NHẬP THIẾT BỊ AN TOÀN",
    "scanTitle": "Quét mã QR đăng nhập",
    "subtitle": "Chỉ các tài khoản có quyền truy cập streamer mới có thể ủy quyền ứng dụng phát trực tiếp đi kèm.",
    "cameraReady": "Sẵn sàng mở camera sau",
    "openingCamera": "Camera mở đầu",
    "cameraActive": "Hướng camera vào mã QR",
    "startCamera": "Quét bằng camera",
    "stopCamera": "Dừng camera",
    "unsupported": "Trình duyệt này không hỗ trợ nhận diện mã QR của camera. Sử dụng trình duyệt được hỗ trợ.",
    "insecure": "Quét camera yêu cầu kết nối HTTPS bảo mật.",
    "permissionDenied": "Không được cấp quyền truy cập camera. Hãy cho phép nó trong cài đặt trình duyệt của bạn.",
    "cameraFailed": "Máy quay không thể khởi động. Kiểm tra quyền thiết bị và trình duyệt, sau đó thử lại.",
    "invalidCode": "Đây không phải là mã QR đăng nhập StarLive hợp lệ.",
    "processingEyebrow": "KIỂM TRA YÊU CẦU AN TOÀN",
    "processingTitle": "Đang kiểm tra yêu cầu đăng nhập",
    "processingTip": "Đang xác minh mã QR và thiết bị yêu cầu. Vui lòng chờ.",
    "confirmEyebrow": "ỦY QUYỀN THIẾT BỊ",
    "confirmTitle": "Đăng nhập trên thiết bị khác?",
    "confirmTip": "Hãy đảm bảo bạn nhận ra ứng dụng và thiết bị bên dưới.",
    "requestFrom": "Ứng dụng",
    "device": "Thiết bị",
    "expires": "Quyền hạn hết hạn",
    "securityNotice": "Ứng dụng đồng hành chỉ nhận được danh tính streamer có phạm vi, tên hiển thị và avatar của bạn. Nó không bao giờ nhận được mật khẩu hoặc mã phiên StarLive của bạn.",
    "approve": "Cho phép đăng nhập",
    "deny": "phủ nhận",
    "approved": "Được ủy quyền đăng nhập",
    "approvedTip": "Thiết bị còn lại đang hoàn tất đăng nhập. Bạn có thể đóng trang này một cách an toàn.",
    "denied": "Yêu cầu đăng nhập bị từ chối",
    "done": "Xong",
    "streamerRequired": "Đăng nhập qua QR chỉ dành cho các tài khoản có quyền truy cập streamer."
  },
  "avatarCrop": {
    "title": "Avatar cắt",
    "cancel": "Hủy",
    "confirm": "Sử dụng avatar",
    "hint": "Kéo để di chuyển ảnh và sử dụng thanh trượt để phóng to. Khu vực hình tròn sẽ trở thành avatar của bạn.",
    "dragHint": "Bản gốc vẫn giữ nguyên trên thiết bị này. Chỉ kết quả đã cắt mới được tải lên sau khi xác nhận.",
    "zoom": "Phóng to ảnh",
    "previewAlt": "Xem trước cắt ảnh avatar",
    "openPicker": "Chụp ảnh hoặc chọn một bức từ thư viện của bạn",
    "presetsTip": "Chọn avatar nền tảng, hoặc chạm vào avatar hiện tại của bạn ở trên để chụp hoặc chọn ảnh",
    "invalidImage": "Chọn một hình ảnh JPEG, PNG hoặc WebP.",
    "sourceTooLarge": "Bức ảnh này quá to. Chọn hình ảnh dưới 20MB với độ phân giải hợp lý.",
    "cropFailed": "Avatar không thể bị cắt. Chọn lại ảnh."
  },
  "liveRoom": {
    "actions": "Thao tác phòng trực tiếp",
    "noLive": "Không có phát trực tiếp",
    "noLiveTip": "Những người sáng tạo đang hoạt động sẽ xuất hiện ở đây ngay khi họ được phát hành.",
    "enter": "Tham gia trực tiếp",
    "back": "Hãy để sống.",
    "live": "TRỰC TIẾP",
    "watching": "{count} nhiệt độ",
    "like": "Như trực tiếp",
    "loading": "Kết nối với luồng trực tiếp...",
    "failed": "Phát trực tiếp không tải được",
    "retry": "Kết nối lại",
    "queueLoading": "Đang tải thêm các buổi phát trực tiếp...",
    "noNextLive": "Hiện tại không còn livestream nữa",
    "noPreviousLive": "Đây là buổi phát trực tiếp đầu tiên",
    "gifts": "Gửi quà",
    "sendCompact": "Gửi",
    "game": "Trò chơi trực tiếp",
    "gameOpen": "Mở trò chơi tương tác trực tiếp",
    "gameTitle": "Trò chơi tương tác trực tiếp",
    "gameEmbedTip": "Được cung cấp bởi phiên trực tiếp này",
    "gameFrameTitle": "Trang trò chơi tương tác trực tiếp",
    "gameLoading": "Đang tải trò chơi…",
    "gameFailed": "Hiện không thể nhúng trò chơi. Hãy thử lại.",
    "gameRetry": "Tải lại",
    "gameClose": "Đóng trò chơi",
    "giftTitle": "Hỗ trợ người sáng tạo",
    "balance": "{count} đồng xu có sẵn",
    "availableBalance": "{count} đồng xu có sẵn",
    "queuedCoins": "{count} đồng xu đã xếp hàng",
    "quantity": "Số lượng",
    "send": "Gửi · {amount} đồng xu",
    "sent": "{name} gửi {gift} × {count}",
    "comments": "Bình luận",
    "muted": "Bật âm thanh",
    "unmuted": "tắt tiếng",
    "quality": "Chất lượng",
    "qualityTitle": "Chất lượng & cách trình bày",
    "qualityAuto": "Tự động",
    "qualityAutoTip": "Thích nghi với mạng và giảm tốc độ khi phát lại không ổn định",
    "quality_original": "Bản gốc",
    "quality_full_hd": "Full HD",
    "quality_hd": "HD",
    "quality_sd": "SD",
    "quality_standard": "Tiêu chuẩn",
    "qualityVariant": "{label} · {code}",
    "bitrate": "{value} kbps",
    "frameRate": "{value} FPS",
    "metadataPending": "Chờ siêu dữ liệu video",
    "displayMode": "Chế độ hiển thị",
    "display_auto": "Tự động lắp đặt",
    "display_contain": "Vừa toàn bộ video",
    "display_cover": "Màn hình lấp đầy",
    "closeQualityPanel": "Bảng điều khiển chất lượng gần",
    "closePanel": "Đóng bảng quà tặng",
    "emptyGift": "Danh mục quà tặng không khả dụng",
    "chatTitle": "Trò chuyện trực tiếp",
    "chatEmpty": "Chưa có tin nhắn nào. Chào hỏi đi!",
    "chatLogin": "Đăng nhập để tham gia trò chuyện trực tiếp",
    "chatPlaceholder": "Trò chuyện với mọi người trong phòng...",
    "chatSend": "Gửi tin nhắn chat",
    "viewersTitle": "Người xem trong phòng",
    "viewersEmpty": "Chưa có người xem đã đăng nhập",
    "viewerRankTip": "Xếp hạng theo quà tặng thành công trong phiên này",
    "paidCoins": "Đã chi {count} xu trong phiên này",
    "host": "Chủ phòng",
    "pinned": "Cố định",
    "closeViewers": "Đóng danh sách người xem",
    "openUserActions": "Tương tác với {name}",
    "mention": "Nhắc đến người xem",
    "mentionList": "Chọn người muốn nhắc đến",
    "mentionUser": "Nhắc đến",
    "viewProfile": "Xem hồ sơ",
    "tapGiftToSend": "Chạm vào quà phía trên để gửi ngay"
  },
  "fanProfile": {
    "title": "Hồ sơ người theo dõi",
    "back": "Quay lại với người theo dõi",
    "loading": "Hồ sơ người theo tải",
    "noBio": "Thành viên này chưa thêm phần giới thiệu.",
    "publicInfo": "Hồ sơ công khai",
    "level": "Mức chi tiêu",
    "country": "Quốc gia",
    "followedAt": "Tiếp theo",
    "wornTitle": "Tiêu đề được trang bị",
    "notSet": "Chưa được thiết lập",
    "creatorProfile": "Hồ sơ người sáng tạo",
    "creatorProfileTip": "Xem các tác phẩm công cộng, phát trực tiếp và nội dung độc quyền"
  },
  "securityUi": {
    "title": "Bảo mật",
    "eyebrow": "BẢO MẬT TÀI KHOẢN",
    "back": "Quay lại cài đặt",
    "loading": "Tải thông tin bảo mật",
    "currentEmail": "Email hiện tại",
    "emailUnbound": "Chưa liên kết email",
    "bindEmail": "Liên kết email bảo mật",
    "bindEmailTip": "Hãy liên kết email trước khi nạp tiền, đổi mật khẩu, xóa tài khoản hoặc đăng nhập thiết bị bên thứ ba",
    "bindBeforeSensitive": "Vui lòng liên kết và xác minh email trước",
    "loginUsername": "Tên người dùng đăng nhập",
    "usernameMissing": "Chưa có tên người dùng",
    "newUsername": "Tên người dùng tùy chỉnh",
    "usernamePlaceholder": "3–64 chữ cái, số, dấu chấm, gạch ngang hoặc gạch dưới",
    "usernameTip": "Tên người dùng tách biệt với biệt danh và có thể dùng để đăng nhập.",
    "submitUsername": "Lưu tên người dùng",
    "savingUsername": "Đang lưu…",
    "usernameChanged": "Tên người dùng đã được cập nhật",
    "usernameInvalid": "Vui lòng nhập tên người dùng hợp lệ",
    "verifiedEmail": "Đã xác minh đăng nhập và khôi phục tài khoản",
    "protected": "được bảo vệ",
    "changeEmail": "Thay đổi email",
    "changeEmailTip": "Xác minh cả địa chỉ email hiện tại và mới của bạn",
    "newEmail": "Email mới",
    "newEmailPlaceholder": "Nhập địa chỉ email mới của bạn",
    "currentCode": "Mã email hiện tại",
    "newCode": "Mã email mới",
    "codePlaceholder": "Nhập mã 6 chữ số",
    "sendCode": "Gửi mã",
    "resendIn": "Gửi lại trong {seconds}s",
    "submitEmail": "Xác nhận thay đổi email",
    "changingEmail": "Thay đổi...",
    "emailChanged": "Email của bạn đã được cập nhật",
    "changePassword": "Thay đổi mật khẩu",
    "changePasswordTip": "Một mã sẽ được gửi đến email hiện tại của bạn",
    "passwordCode": "Mã email",
    "newPassword": "Mật khẩu mới",
    "passwordPlaceholder": "8–72 ký tự có chữ cái và số",
    "confirmPassword": "Xác nhận mật khẩu mới",
    "confirmPasswordPlaceholder": "Nhập lại mật khẩu mới",
    "submitPassword": "Xác nhận thay đổi mật khẩu",
    "changingPassword": "Thay đổi...",
    "passwordChanged": "Mật khẩu của bạn đã được cập nhật",
    "otherSessions": "Sau khi thay đổi bảo mật, các thiết bị khác sẽ được đăng xuất trong khi thiết bị này vẫn giữ trạng thái đăng nhập.",
    "emailRequired": "Nhập địa chỉ email mới hợp lệ",
    "codeRequired": "Nhập mã xác minh 6 chữ số",
    "passwordInvalid": "Sử dụng từ 8–72 ký tự với ít nhất một chữ cái và một số",
    "passwordMismatch": "Mật khẩu không khớp",
    "deviceEyebrow": "CÁC PHIÊN LÀM VIỆC ĐANG HOẠT ĐỘNG",
    "loginDevices": "Thiết bị đã đăng nhập",
    "loginDevicesTip": "Xem lại các trình duyệt và các ứng dụng streaming đi kèm vẫn có thể truy cập tài khoản này",
    "currentDevice": "Thiết bị hiện tại",
    "companionDevice": "Khách hàng streamer",
    "h5Session": "Đăng nhập web StarLive",
    "unknownDevice": "Thiết bị không xác định",
    "unknownIp": "Mạng không xác định",
    "lastActive": "Hoạt động cuối cùng",
    "forceLogout": "Đăng xuất ra",
    "revoking": "Đăng xuất ra...",
    "revokeTitle": "Thiết bị đăng xuất",
    "revokeConfirm": "Đăng nhập \"{device}\" khỏi tài khoản này?",
    "revokeSuccess": "Thiết bị đã được đăng xuất",
    "deviceEmpty": "Không có thiết bị đăng nhập đang hoạt động",
    "scanEyebrow": "LỊCH SỬ QR AUTH",
    "scanRecords": "Lịch sử đăng nhập QR",
    "scanRecordsTip": "Hiển thị các yêu cầu ủy quyền thiết bị mà bạn đã phê duyệt hoặc từ chối",
    "scanEmpty": "Không có bản ghi đăng nhập QR",
    "loadMore": "Xem thêm",
    "loadingMore": "Đang tải...",
    "scanStatus": {
      "pending": "Đang chờ xử lý",
      "approved": "Được ủy quyền",
      "denied": "bị từ chối",
      "consumed": "Đăng nhập",
      "expired": "Đã hết hạn"
    },
    "authMethod": {
      "user": "Đăng nhập web",
      "qr": "Đăng nhập qua QR",
      "password": "Email và mật khẩu"
    }
  },
  "guildUi": {
    "settingsTitle": "Mối quan hệ trong bang hội",
    "settingsTip": "Xem lại lời mời, trạng thái gia nhập, rời đi và chuyển giao",
    "title": "Mối quan hệ trong bang hội",
    "eyebrow": "HỘI SÁNG TẠO",
    "back": "Quay lại mối quan hệ trong bang hội",
    "notEligibleTitle": "Chưa có sẵn",
    "notEligible": "Quyền truy cập của người sáng tạo hoặc chủ nhà là bắt buộc để nhận và quản lý lời mời bang hội.",
    "currentGuild": "Hội hiện tại",
    "level": "Cấp bang hội {level}",
    "share": "Tỷ lệ người sáng tạo {percent}%",
    "joinedAt": "Đã tham gia {time}",
    "creatorShare": "Tỷ lệ quà tặng trực tiếp",
    "joinDate": "Thời gian gia nhập (giờ Trung Quốc)",
    "noGuild": "Chưa có bang hội nào",
    "noGuildTip": "Một bang hội có thể hỗ trợ hoạt động, định cư và phát triển của người sáng tạo.",
    "findGuild": "Đăng ký tham gia",
    "requests": "Hoạt động của hội",
    "requestEyebrow": "HOẠT ĐỘNG THÀNH VIÊN",
    "noRequests": "Chưa có yêu cầu từ bang hội nào",
    "invite": "Lời mời hội",
    "join": "Yêu cầu tham gia",
    "exit": "Yêu cầu nghỉ phép",
    "transfer": "Yêu cầu chuyển công tác",
    "pending": "Đang chờ xử lý",
    "approved": "Được phê duyệt",
    "rejected": "Bị từ chối",
    "canceled": "Không khả dụng",
    "accept": "Chấp nhận",
    "decline": "Suy tàn",
    "acceptInvitation": "Chấp nhận lời mời",
    "exitAction": "Yêu cầu rời đi",
    "transferAction": "Yêu cầu chuyển",
    "exitPending": "Yêu cầu nghỉ phép đang chờ xử lý",
    "transferPending": "Chuyển giao đang chờ xử lý",
    "searchPlaceholder": "Tìm kiếm tên hoặc mã bang hội",
    "relationshipPendingTitle": "{type} đang chờ xử lý",
    "relationshipPendingTip": "Thành viên của bạn sẽ tự động được cập nhật sau khi xem xét",
    "requestSheetEyebrow": "YÊU CẦU MỐI QUAN HỆ",
    "exitRequestTitle": "Rời khỏi bang hội hiện tại",
    "exitRequestDescription": "Bang hội hiện tại của bạn sẽ xem xét yêu cầu này. Bạn vẫn là thành viên cho đến khi được phê duyệt.",
    "joinRequestTitle": "Đăng ký gia nhập bang hội",
    "joinRequestDescription": "Chọn một bang hội và gửi yêu cầu của bạn. Bạn sẽ tham gia sau khi được chấp thuận.",
    "transferRequestTitle": "Chuyển sang bang hội mới",
    "transferRequestDescription": "Thành viên của bạn sẽ được cập nhật tự động sau khi bang hội mới phê duyệt.",
    "targetGuild": "Bang hội điểm đến",
    "reasonLabel": "Yêu cầu ghi chú",
    "optional": "Tùy chọn",
    "reasonPlaceholder": "Thêm lý do hoặc thông tin cho bang hội",
    "submit": "Gửi yêu cầu",
    "submitting": "Đang nộp",
    "selectGuild": "Chọn bang hội",
    "inviteAccepted": "Bạn đã gia nhập hội",
    "inviteDeclined": "Lời mời bị từ chối",
    "requestSubmitted": "Yêu cầu đã gửi",
    "requestSubmittedDetail": "Yêu cầu đã nộp và đang chờ bang hội xem xét",
    "invitedBy": "Mời bạn tham gia",
    "exitDetailEyebrow": "YÊU CẦU NGHỈ PHÉP",
    "transferDetailEyebrow": "YÊU CẦU CHUYỂN GIAO",
    "joinDetailEyebrow": "YÊU CẦU THAM GIA",
    "guildCountry": "Khu vực Guild",
    "global": "Toàn cầu",
    "requestNumber": "Mã yêu cầu",
    "invitedAt": "Được mời tại",
    "submittedAt": "Gửi tại",
    "invitationNote": "Ghi chú mời",
    "noInvitationNote": "Hội này không thêm bất kỳ ghi chú nào.",
    "requestNote": "Yêu cầu ghi chú",
    "noRequestNote": "Không có ghi chú yêu cầu nào được thêm vào.",
    "reviewNote": "Ghi chú đánh giá",
    "outgoingRequestPending": "Yêu cầu của bạn đã được gửi thành công và đang chờ bang hội xem xét. Thành viên của bạn sẽ được cập nhật tự động sau khi được xem xét.",
    "inviteUnavailable": "Lời mời này không thể xử lý. Nó có thể đã hết hạn, bang hội có thể bị vô hiệu hóa, hoặc bạn có thể đã thuộc bang hội khác.",
    "acceptConfirmTitle": "Tham gia hội này?",
    "acceptConfirmContent": "Chấp nhận lời mời từ {guild}? Việc rời đi hoặc chuyển công tác sau này cần có yêu cầu riêng.",
    "declineConfirmTitle": "Từ chối lời mời?",
    "declineConfirmContent": "Từ chối lời mời từ {guild}? Hành động này không thể đảo ngược.",
    "notificationTitle": "Lời mời hội mới",
    "notificationContent": "{actor} đã mời bạn gia nhập một hội. Nhấn để xem lại chi tiết.",
    "errors": {
      "GUILD.DISABLED": "Hội này đang chờ phê duyệt hoặc bị vô hiệu hóa.",
      "GUILD.CREATOR_ALREADY_JOINED": "Bạn đã thuộc về một bang hội và không thể nhận lời mời khác.",
      "GUILD.REQUEST_PENDING": "Một yêu cầu kiểu này hiện đang được xử lý.",
      "GUILD.MEMBERSHIP_REQUIRED": "Không tìm thấy thành viên hội đang hoạt động.",
      "GUILD.INVALID_TARGET": "Bang hội điểm đến không khả dụng.",
      "GUILD.PERMISSION_DENIED": "Bạn không thể xử lý yêu cầu của bang hội này.",
      "GUILD.SHARE_EXCEEDS_LEVEL": "Phần chia sẻ của người tạo vượt quá mức phân bổ của cấp bang hội này.",
      "GUILD.INVITE_ALREADY_HANDLED": "Lời mời này đã được xử lý hoặc không còn khả dụng. Làm mới để xem trạng thái mới nhất của nó."
    }
  }
}
